/* 3M Textile — comportements des composants partagés */
(function () {
  'use strict';

  /* --- Carrousel de la carte produit -------------------------------------- */
  function initCard(card) {
    if (card.dataset.m3CardReady) return;
    card.dataset.m3CardReady = '1';

    var imgs = card.querySelectorAll('[data-m3-card-img]');
    var dots = card.querySelectorAll('[data-m3-card-dot]');
    var prev = card.querySelector('[data-m3-card-prev]');
    var next = card.querySelector('[data-m3-card-next]');
    if (imgs.length < 2) return;

    var i = 0;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      dots.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
    }
    function step(d) { return function (e) { e.preventDefault(); e.stopPropagation(); show(i + d); }; }

    if (prev) prev.addEventListener('click', step(-1));
    if (next) next.addEventListener('click', step(1));

    /* Au survol, la carte montre la deuxième photo : le client voit le dos
       de la pièce sans cliquer. On ne le fait que si l'appareil sait
       survoler, et on revient à la première en sortant — sauf si le client
       a lui-même navigué avec les flèches, auquel cas son choix prime. */
    var navigue = false;
    if (prev) prev.addEventListener('click', function () { navigue = true; });
    if (next) next.addEventListener('click', function () { navigue = true; });

    if (window.matchMedia('(hover: hover)').matches) {
      card.addEventListener('mouseenter', function () { if (!navigue) show(1); });
      card.addEventListener('mouseleave', function () { if (!navigue) show(0); });
    }

    /* Balayage tactile */
    var x0 = null;
    card.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    card.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-m3-card]').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(); });
  boot();

  // Exposé pour que les cartes ajoutées après coup (« Afficher plus »)
  // reçoivent leur carrousel.
  window.M3 = window.M3 || {};
  window.M3.bootCards = boot;

  /* Les documents légaux de Shopify arrivent souvent en texte brut, sans
     balises de titre : les sections y sont numérotées « SECTION 1 – … » ou
     « ARTICLE 8 – … ». On les promeut en titres pour que le sommaire les
     capte. Motif volontairement strict : aucune ligne ordinaire ne le
     déclenche par accident. */
  var MOTIF_TITRE = /^(SECTION|ARTICLE|PARTIE|CHAPITRE)\s*\d+\s*[–—-]/i;

  function promouvoirTitres(racine) {
    if (racine.querySelectorAll('h2, h3').length >= 2) return;
    var conteneur = racine.querySelector('.rte') || racine;
    var noeuds = Array.prototype.slice.call(conteneur.childNodes);
    noeuds.forEach(function (n) {
      if (n.nodeType !== 3) return;
      var texte = n.textContent.replace(/\u00a0/g, ' ').trim();
      if (!texte || !MOTIF_TITRE.test(texte) || texte.length > 120) return;
      var h = document.createElement('h2');
      h.textContent = texte;
      n.parentNode.replaceChild(h, n);
    });
  }

  /* --- Sommaire des pages de contenu ---------------------------------------
     Construit depuis les titres du texte : le contenu légal vient de Shopify
     et n'est pas rédigé dans le thème. Vaut pour les pages comme pour les
     routes /policies/, qui n'ont pas de gabarit. */
  function bootToc() {
    var article = document.querySelector('[data-m3-article]');
    var toc = document.querySelector('[data-m3-toc]');
    var liste = document.querySelector('[data-m3-toc-list]');
    if (!article || !toc || !liste || liste.children.length) return;

    promouvoirTitres(article);

    var titres = article.querySelectorAll('h2, h3');
    if (titres.length < 2) return;

    var liens = [];
    titres.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'm3-toc__item t-small';
      a.textContent = h.textContent.trim();
      liste.appendChild(a);
      liens.push(a);
    });
    toc.hidden = false;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          liens.forEach(function (a) {
            a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id);
          });
        });
      }, { rootMargin: '-120px 0px -70% 0px' });
      titres.forEach(function (h) { obs.observe(h); });
    }
  }
  document.addEventListener('DOMContentLoaded', bootToc);
  bootToc();

  /* L'éditeur de thème recharge les sections : on réinitialise */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* ==========================================================================
   Overlays — recherche, panier, newsletter
   Chacun se ferme par sa croix, par le voile ou par Échap.
   ========================================================================== */
(function () {
  'use strict';

  var scrim = document.querySelector('[data-m3-scrim]');
  if (!scrim) return;
  var ouverts = [];

  function ouvrir(nom) {
    var ov = document.querySelector('[data-m3-ov="' + nom + '"]');
    if (!ov || ov.classList.contains('is-open')) return;
    ov.classList.add('is-open');
    ov.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-open'); });
    document.body.classList.add('m3-locked');
    ouverts.push(nom);
    var champ = ov.querySelector('input:not([type=hidden])');
    if (champ) setTimeout(function () { champ.focus(); }, 320);
  }

  function fermer(nom) {
    var ov = nom
      ? document.querySelector('[data-m3-ov="' + nom + '"]')
      : document.querySelector('[data-m3-ov].is-open');
    if (!ov) return;
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden', 'true');
    ov.dispatchEvent(new CustomEvent('m3:ferme'));
    ouverts = ouverts.filter(function (n) { return n !== ov.dataset.m3Ov; });
    if (!document.querySelector('[data-m3-ov].is-open')) {
      scrim.classList.remove('is-open');
      document.body.classList.remove('m3-locked');
      setTimeout(function () { scrim.hidden = true; }, 300);
    }
  }

  window.M3 = window.M3 || {};
  window.M3.ouvrirOverlay = ouvrir;
  window.M3.fermerOverlay = fermer;

  scrim.addEventListener('click', function () { fermer(); });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-m3-ov-close]');
    if (c) { e.preventDefault(); fermer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });

  /* --- Déclencheurs dans l'en-tête ---------------------------------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (a.closest('[data-m3-ov]')) return;

    if (/\/search\b/.test(href) && !a.closest('form')) {
      e.preventDefault(); ouvrir('search');
    } else if (/\/cart\b/.test(href) && !a.classList.contains('m3-cart__checkout')) {
      e.preventDefault(); ouvrir('cart');
    }
  });

  /* --- Menu mobile : ouverture et accordéon -------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-m3-burger]')) { e.preventDefault(); ouvrir('menu'); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-m3-menu-toggle]');
    if (!t) return;
    e.preventDefault();
    var parent = t.closest('[data-m3-menu-parent]');
    var sub = parent.nextElementSibling;
    if (!sub || !sub.hasAttribute('data-m3-menu-sub')) return;
    var ouvert = sub.hidden;
    sub.hidden = !ouvert;
    parent.classList.toggle('is-open', ouvert);
    t.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  });

  /* --- Recherche : suggestions et produits -------------------------------- */
  var champ = document.querySelector('[data-m3-search-input]');
  var zone = document.querySelector('[data-m3-search-results]');
  if (champ && zone) {
    var minuteur = null;
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      var q = champ.value.trim();
      if (q.length < 2) { zone.innerHTML = ''; return; }
      minuteur = setTimeout(function () { chercher(q); }, 250);
    });
  }

  function chercher(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product,collection,query&resources[limit]=5';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var r = (d.resources && d.resources.results) || {};
        var html = '';

        var idees = (r.queries || []).concat(r.collections || []);
        if (idees.length) {
          html += '<div class="m3-ov__group"><p class="t-badge m3-muted">' + T('suggestions') + '</p>';
          idees.slice(0, 5).forEach(function (s) {
            html += '<a class="m3-sugg t-small" href="' + s.url + '">' + echapper(s.title) + '</a>';
          });
          html += '</div>';
        }

        if ((r.products || []).length) {
          html += '<div class="m3-ov__group"><p class="t-badge m3-muted">' + T('produits') + '</p>';
          r.products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            html += '<a class="m3-hit" href="' + p.url + '">'
                  + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="m3-hit__ph"></span>')
                  + '<span class="m3-hit__txt"><span class="t-product-title">' + echapper(p.title) + '</span>'
                  + '<span class="t-price">' + window.M3.prix(p.price) + '</span></span></a>';
          });
          html += '</div>';
        }

        if (!html) {
          html = '<div class="m3-ov__group"><p class="t-small m3-muted">' + T('aucunResultat') + '</p></div>';
        }
        zone.innerHTML = html;
      })
      .catch(function () { zone.innerHTML = ''; });
  }

  function echapper(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  /* --- Panier : quantités ------------------------------------------------- */
  var corps = document.querySelector('[data-m3-cart-body]');
  if (corps) {
    corps.addEventListener('click', function (e) {
      var retrait = e.target.closest('[data-m3-remove]');
      var b = retrait || e.target.closest('[data-m3-qty]');
      if (!b) return;
      var ligne = b.closest('[data-m3-cart-line]');
      var n;
      if (retrait) {
        n = 0;
      } else {
        var valeur = ligne.querySelector('[data-m3-qty-value]');
        n = parseInt(valeur.textContent, 10) || 0;
        n = b.dataset.m3Qty === 'plus' ? n + 1 : n - 1;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(ligne.dataset.m3CartLine, 10), quantity: Math.max(n, 0) })
      })
        .then(function (r) { return r.json(); })
        .then(function () { location.reload(); })
        .catch(function () { location.reload(); });
    });
  }

  /* --- Quelques produits, puis « Voir plus » --------------------------------
     Grilles de l'accueil (Nouveautés, Best-sellers) et du catalogue. Sous
     768 px : trois produits en une colonne, deux rangées en deux colonnes ;
     chaque « Voir plus » en ajoute toujours trois, quel que soit l'affichage
     (consigne client du 29/09/2026), et au dernier clic ce qui reste, un ou
     deux. Dans
     le catalogue, quand la page chargée est épuisée, le bouton va chercher
     la suivante : la pagination « Afficher plus » reste cachée sur mobile,
     un seul bouton pilote tout. Sur ordinateur, les grilles qui portent
     data-m3-plus-bureau (Nouveautés) montrent deux rangées, puis une de plus
     à chaque clic, et « Voir tout » à la fin. */
  var mobilePlus = window.matchMedia('(max-width: 767px)');
  function colonnesDe(g) {
    return getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
  }
  function estProduit(e) { return e.classList.contains('m3-card'); }
  // Mode de la grille : « mobile » sous 768 px ; « bureau » au-delà, pour
  // les grilles qui l'activent (Nouveautés, demande du client du
  // 29/09/2026) ; sinon aucun repli.
  function modeDe(g) {
    if (mobilePlus.matches) return 'mobile';
    return g.hasAttribute('data-m3-plus-bureau') ? 'bureau' : '';
  }
  // Point de départ : trois produits en une colonne, deux rangées sinon.
  function departDe(g, mode, cols) {
    if (mode === 'bureau') return cols * 2;
    return cols === 1 ? 3 : 4;
  }
  function replierGrille(g) {
    var cols = colonnesDe(g);
    var mode = modeDe(g);
    g.setAttribute('data-m3-colonnes', String(cols));
    // En changeant de mode (rotation, fenêtre redimensionnée), on repart du
    // début : les comptes mobile et bureau ne se mesurent pas pareil.
    if (g.dataset.m3Mode !== mode) {
      g.dataset.m3Mode = mode;
      delete g.dataset.m3Visibles;
    }
    if (!g.dataset.m3Visibles) g.dataset.m3Visibles = String(departDe(g, mode, cols));
    var visibles = parseInt(g.dataset.m3Visibles, 10);
    // Sur ordinateur on avance par rangées pleines, même si le nombre de
    // colonnes vient de changer (bureau 3, tablette 2).
    if (mode === 'bureau') visibles = Math.ceil(visibles / cols) * cols;
    var listing = g.closest('[data-m3-listing]');
    var pager = listing ? listing.querySelector('[data-m3-pager]') : null;
    var suivante = pager ? pager.querySelector('[data-m3-loadmore]') : null;
    var actif = mode !== '';
    // Seuls comptent les éléments réellement affichables : un bloc que le CSS
    // masque déjà sur mobile ne prend pas de place.
    var enfants = Array.prototype.slice.call(g.children);
    enfants.forEach(function (e) { e.classList.remove('m3-replie'); });
    enfants = enfants.filter(function (e) { return getComputedStyle(e).display !== 'none'; });
    // Sur mobile on compte des produits, pas des cases : le bandeau éditorial
    // glissé dans la grille s'affiche en passant, sans prendre une des trois
    // places. Sur ordinateur on compte des cases, pour des rangées pleines :
    // la tuile Lookbook y occupe la sienne.
    var compte = mode === 'bureau' ? function () { return true; } : estProduit;
    var total = enfants.filter(compte).length;
    var vus = 0;
    enfants.forEach(function (e) {
      var montrer = !actif || vus < visibles || (vus >= total && visibles >= total);
      if (compte(e)) vus++;
      e.classList.toggle('m3-replie', !montrer);
    });
    if (pager) pager.classList.toggle('m3-replie', mode === 'mobile');
    // « Voir plus » tant qu'il reste des pièces. Une fois tout affiché, le
    // bouton s'efface : sur l'accueil, un lien vers la suite prend sa place ;
    // dans le catalogue, une ligne « Vous avez vu les N pièces ».
    var plus = actif && (total > visibles || (mode === 'mobile' && !!suivante));
    var fin = actif && !plus && total > departDe(g, mode, cols);
    var bloc = g.nextElementSibling && g.nextElementSibling.classList.contains('m3-plus') ? g.nextElementSibling : null;
    if (plus && !bloc) {
      bloc = document.createElement('div');
      bloc.className = 'm3-plus';
      bloc.innerHTML = '<button type="button" class="m3-btn m3-btn--line t-button"></button>';
      bloc.firstChild.textContent = T('voirPlus') || 'Voir plus';
      g.parentNode.insertBefore(bloc, g.nextSibling);
      bloc.firstChild.addEventListener('click', function () { voirPlus(g); });
    }
    if (bloc) bloc.hidden = !plus;
    var finEl = g.parentNode.querySelector(':scope > .m3-fin');
    if (finEl) finEl.hidden = !fin;
  }
  function voirPlus(g) {
    // Mobile : toujours trois produits. Ordinateur : une rangée.
    var mode = modeDe(g);
    var pas = mode === 'bureau' ? colonnesDe(g) : 3;
    var avant = parseInt(g.dataset.m3Visibles, 10);
    var caches = Array.prototype.slice.call(g.querySelectorAll(':scope > .m3-replie'));
    g.dataset.m3Visibles = String(avant + pas);
    // Page épuisée : on charge la suivante (catalogue). Ses cartes arrivent
    // repliées, sauf celles qui complètent les trois demandées.
    var produits = g.querySelectorAll(':scope > .m3-card').length;
    if (mode === 'mobile' && avant + pas > produits) {
      var listing = g.closest('[data-m3-listing]');
      var suivante = listing && listing.querySelector('[data-m3-pager] [data-m3-loadmore]');
      if (suivante) { g._m3Attente = true; suivante.click(); }
    }
    replierGrille(g);
    var montres = caches.filter(function (e) { return !e.classList.contains('m3-replie'); });
    montres.forEach(function (e) { e.classList.add('m3-devoile'); });
    var lien = montres.length && montres[0].querySelector('a[href]');
    if (lien) lien.focus({ preventScroll: true });
    // La page s'allonge : les sections suivantes recalculent le moment où
    // elles apparaissent.
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }
  function replierTout() {
    document.querySelectorAll('.m3-section--grid .m3-grid, [data-m3-listing] .m3-grid--listing').forEach(function (g) {
      replierGrille(g);
      if (!g._m3Observe) {
        g._m3Observe = true;
        // « Afficher comme » change les colonnes (attribut style) ; la page
        // suivante du catalogue ajoute des cartes (enfants) : on recalcule.
        new MutationObserver(function (m) {
          var ajouts = [];
          m.forEach(function (x) { if (x.type === 'childList') ajouts = ajouts.concat(Array.prototype.slice.call(x.addedNodes)); });
          replierGrille(g);
          if (ajouts.length && g._m3Attente) {
            ajouts.forEach(function (e) { if (e.nodeType === 1 && !e.classList.contains('m3-replie')) e.classList.add('m3-devoile'); });
            g._m3Attente = false;
          }
        }).observe(g, { attributes: true, attributeFilter: ['style'], childList: true });
      }
    });
  }
  replierTout();
  mobilePlus.addEventListener('change', replierTout);
  var retaille;
  window.addEventListener('resize', function () { clearTimeout(retaille); retaille = setTimeout(replierTout, 150); });
  document.addEventListener('shopify:section:load', replierTout);

  /* --- Newsletter : apparition au défilement de l'accueil ------------------
     Conditions : la moitié de la page parcourue (réglage du thème), au moins
     20 s sur la page, et la bannière cookies déjà écartée. */
  var news = document.querySelector('[data-m3-ov="news"]');
  if (news && document.body.classList.contains('template-index')) {
    var CLE = 'm3-news-vue';
    var REPOS = 7 * 24 * 60 * 60 * 1000;   // on laisse sept jours de répit

    // Le drapeau se pose quand le visiteur écarte la modale, pas quand elle
    // s'ouvre : sinon un simple rechargement pendant l'affichage la retirait
    // définitivement. Il expire au bout d'une semaine, pour ne pas condamner
    // la modale à une seule apparition dans la vie du navigateur.
    var deja = false;
    try {
      var pose = parseInt(localStorage.getItem(CLE) || '0', 10);
      deja = pose > 0 && (Date.now() - pose) < REPOS;
    } catch (e) {}

    if (!deja) {
      var seuil = parseInt(news.dataset.m3Seuil || '50', 10);
      var minuterie = null;
      // Audit du 29/09/2026 : jamais dans les 20 premières secondes, et
      // jamais par-dessus la bannière cookies encore sans réponse — sinon
      // un visiteur qui défile vite empilait bandeau, cookies et newsletter.
      var ouvertureMin = Date.now() + 20000;
      var cookiesEnAttente = function () {
        var b = document.querySelector('.shopify-pc__banner__dialog') || document.querySelector('#shopify-pc__banner');
        if (!b) return false;
        var st = getComputedStyle(b);
        return st.display !== 'none' && st.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
      };
      var surveiller = function () {
        var h = document.documentElement.scrollHeight - innerHeight;
        if (h <= 0) return;
        if (Date.now() < ouvertureMin || cookiesEnAttente()) return;
        if ((scrollY / h) * 100 >= seuil) {
          window.removeEventListener('scroll', surveiller);
          clearInterval(minuterie);
          ouvrir('news');
        }
      };
      window.addEventListener('scroll', surveiller, { passive: true });

      // Doublure : certains contextes déplacent la page sans émettre
      // d'événement « scroll » — défilement programmé, restauration de
      // position, navigateurs mobiles pendant l'inertie. Un relevé léger
      // garantit que la modale paraît quand même.
      minuterie = setInterval(surveiller, 500);

      news.addEventListener('m3:ferme', function () {
        try { localStorage.setItem(CLE, String(Date.now())); } catch (e) {}
      });
    }
  }
})();

/* ==========================================================================
   Textes — fournis par Liquid dans la langue de la page (voir theme.liquid).
   ========================================================================== */
function T(cle) {
  var d = (window.M3 && window.M3.i18n) || {};
  return d[cle] || '';
}

/* ==========================================================================
   Prix — une seule graphie sur tout le site.
   Les API de Shopify (recherche prédictive, /products/*.js) renvoient des
   nombres bruts ; le filtre « money » n'existe qu'en Liquid. On recompose
   donc ici la sortie de « money » à partir du format de la boutique, pour
   que les prix des overlays soient identiques à ceux des fiches produit.
   ========================================================================== */
(function () {
  'use strict';
  window.M3 = window.M3 || {};

  function grouper(entier, separateur) {
    return entier.replace(/\B(?=(\d{3})+(?!\d))/g, separateur);
  }

  // centimes : entier (4990) ou chaîne décimale ("49.90")
  window.M3.prix = function (valeur) {
    var format = window.M3.formatPrix || '\u20ac{{amount_with_comma_separator}}';
    var centimes;
    if (typeof valeur === 'string' && valeur.indexOf('.') > -1) {
      centimes = Math.round(parseFloat(valeur) * 100);
    } else {
      centimes = parseInt(valeur, 10);
    }
    if (!isFinite(centimes)) return '';

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, cle) {
      var virgule = cle.indexOf('comma_separator') > -1;
      var sansDecimales = cle.indexOf('no_decimals') > -1;
      var n = (centimes / 100).toFixed(sansDecimales ? 0 : 2).split('.');
      n[0] = grouper(n[0], virgule ? '.' : ',');
      return n.length > 1 ? n.join(virgule ? ',' : '.') : n[0];
    });
  };
})();

/* ==========================================================================
   Favoris — absent de la maquette, ajouté à la demande du client.
   Les choix vivent dans le navigateur du visiteur : aucun compte requis.
   Seuls les identifiants sont stockés ; le prix et l'image sont relus chez
   Shopify à l'ouverture, pour ne jamais afficher un prix périmé.
   ========================================================================== */
(function () {
  'use strict';
  var CLE = 'm3-favoris';

  function lire() {
    try { return JSON.parse(localStorage.getItem(CLE) || '[]'); } catch (e) { return []; }
  }
  function ecrire(liste) {
    try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) {}
    majCompteur();
    majBoutons();
  }
  function majCompteur() {
    var n = lire().length;
    document.querySelectorAll('[data-m3-fav-badge]').forEach(function (b) {
      b.textContent = n;
      var parent = b.closest('.m3-util--fav');
      if (parent) parent.classList.toggle('has-items', n > 0);
    });
    document.querySelectorAll('[data-m3-fav-count]').forEach(function (c) { c.textContent = n; });
  }
  function majBoutons() {
    var liste = lire();
    document.querySelectorAll('[data-m3-fav]').forEach(function (b) {
      var on = liste.indexOf(b.dataset.m3Fav) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      // Le libellé suit l'état : « Ajouter » devient « Retirer ».
      var libelle = on ? b.dataset.m3FavRetrait : b.dataset.m3FavAjout;
      if (libelle) b.setAttribute('aria-label', libelle);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-m3-fav]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var h = b.dataset.m3Fav;
      var liste = lire();
      var i = liste.indexOf(h);
      if (i > -1) liste.splice(i, 1); else liste.push(h);
      ecrire(liste);

      // Le rebond ne vaut que pour le bouton qu'on vient de toucher.
      if (b.classList.contains('m3-fav')) {
        b.classList.remove('vient-de-basculer');
        void b.offsetWidth;              // force la relance de l'animation
        b.classList.add('vient-de-basculer');
        setTimeout(function () { b.classList.remove('vient-de-basculer'); }, 400);
      }
      return;
    }
    var o = e.target.closest('[data-m3-open]');
    if (o && window.M3 && window.M3.ouvrirOverlay) {
      e.preventDefault();
      // Déclenché depuis le menu mobile : on referme le panneau d'où l'on
      // vient, sinon les deux surfaces se superposent.
      var parent = o.closest('[data-m3-ov]');
      if (parent && window.M3.fermerOverlay) window.M3.fermerOverlay(parent.dataset.m3Ov);
      window.M3.ouvrirOverlay(o.dataset.m3Open);
      if (o.dataset.m3Open === 'fav') rendreFavoris();
    }
  });

  function rendreFavoris() {
    var zone = document.querySelector('[data-m3-fav-body]');
    if (!zone) return;
    var liste = lire();

    if (!liste.length) {
      zone.innerHTML = '<div class="m3-fav__empty">'
        + '<p class="t-sub">' + T('favVideTitre') + '</p>'
        + '<p class="t-small m3-muted">' + T('favVideTexte') + '</p>'
        + '<a href="/collections/all" class="m3-btn m3-btn--ink t-button">' + T('voirCatalogue') + '</a></div>';
      return;
    }

    zone.innerHTML = '<p class="t-small m3-muted" style="padding:22px 28px">' + T('chargement') + '</p>';
    Promise.all(liste.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (produits) {
      var valides = produits.filter(Boolean);

      // Un produit retiré de la boutique disparaît aussi des favoris
      if (valides.length !== liste.length) {
        ecrire(valides.map(function (p) { return p.handle; }));
      }
      if (!valides.length) { rendreFavoris(); return; }

      var html = '<ul class="m3-fav__items">';
      valides.forEach(function (p) {
        var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
        var prix = window.M3.prix(p.price);
        html += '<li class="m3-fav__item">'
          + '<a class="m3-fav__thumb" href="' + p.url + '">'
          + (img ? '<img src="' + img + '&width=240" alt="" width="96" height="122" loading="lazy">' : '')
          + '</a>'
          + '<div class="m3-fav__info">'
          + '<a class="t-product-title" href="' + p.url + '">' + echapperTexte(p.title) + '</a>'
          + '<p class="t-price">' + prix + '</p>'
          + (p.available ? '' : '<p class="t-micro m3-muted">' + T('epuise') + '</p>')
          + '</div>'
          + '<button type="button" class="m3-fav__remove" data-m3-fav="' + p.handle + '" aria-label="Retirer des favoris">✕</button>'
          + '</li>';
      });
      html += '</ul>';
      zone.innerHTML = html;
      majBoutons();
    });
  }

  function echapperTexte(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  // Le contenu se redessine quand on retire depuis le tiroir
  document.addEventListener('click', function (e) {
    if (e.target.closest('.m3-fav__remove')) setTimeout(rendreFavoris, 0);
  });

  document.addEventListener('DOMContentLoaded', function () { majCompteur(); majBoutons(); });
  majCompteur(); majBoutons();

  window.M3 = window.M3 || {};
  window.M3.rendreFavoris = rendreFavoris;
  window.M3.majFavoris = function () { majCompteur(); majBoutons(); };
})();
